import Board from '@/models/Board'
import BoardOwned from '@/models/BoardOwned'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    boardDetails: null
  },

  mutations: {
    setBoardList(state, boards) {
      each(boards, board => {
        const exist = find(state.list, { id: board.id })
        if (!exist) {
          state.list.push(new Board(board))
        }
      })
    },

    clearBoardList(state) {
      state.list = []
    },

    setBoardListMeta(state, meta) {
      state.listMeta = meta
    },

    setBoardDetails(state, board) {
      if (board instanceof Board) {
        state.boardDetails = board
      } else {
        state.boardDetails = new Board(board)
      }
    },

    clearBoardDetails(state) {
      state.boardDetails = null
    }
  },

  actions: {
    async getBoards({ commit, rootState }, params) {
      const query =
        rootState.auth.user.user_role === 'SITE_OWNER'
          ? BoardOwned.page(params.page || 1)
          : Board.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query
        .params({ limit: 20 })
        .include('qrcode')
        .get()

      commit('setBoardList', res.data)
      commit('setBoardListMeta', res.meta)
    }
  }
}
